import styled from 'styled-components';

export const Container = styled.div`
    cursor: pointer;
    background-color: var(--color-lemon);
    padding: 1rem 1.5rem;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .left-section {
        h4,
        p {
            color: var(--color-neutral-darkness);
        }
    }

    .right-section {
        > .button {
            background-color: var(--color-neutral-dark);
        }
    }
`;
